export const ICOTokenContract = "0x0f5F5b69aDfF3B3CE619593785322d60Ddf1d616"; // Hammada ico address
export const USDTToken = "0x433b5025BE88f9425f6402a2B0701FdDCd0eef8d"; // USDTToken
export const RanpoToken = "0x5C7614E9371B3Cd836ea3c6d2800967f73Fdc1aB";
